import { render, staticRenderFns } from "./Template.vue.js?vue&type=template&id=6845f2d8!=!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@7.1.2_@rspack+core@1.5.8_@swc+helpers@0.5.17__webpack@5.1_3d0faac70f5997e79e952e2be0702c36/node_modules/vue-loader/lib/index.js??vue-loader-options!./Template.vue?vue&type=template&id=6845f2d8"
import script from "./Template.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@7.1.2_@rspack+core@1.5.8_@swc+helpers@0.5.17__webpack@5.1_3d0faac70f5997e79e952e2be0702c36/node_modules/vue-loader/lib/index.js??vue-loader-options!./Template.vue?vue&type=script&lang=js"
export * from "./Template.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@7.1.2_@rspack+core@1.5.8_@swc+helpers@0.5.17__webpack@5.1_3d0faac70f5997e79e952e2be0702c36/node_modules/vue-loader/lib/index.js??vue-loader-options!./Template.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@7.1.2_@rspack+core@1.5.8_@swc+helpers@0.5.17__webpack@5.1_3d0faac70f5997e79e952e2be0702c36/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6845f2d8')) {
      api.createRecord('6845f2d8', component.options)
    } else {
      api.reload('6845f2d8', component.options)
    }
    module.hot.accept("./Template.vue.js?vue&type=template&id=6845f2d8!=!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@7.1.2_@rspack+core@1.5.8_@swc+helpers@0.5.17__webpack@5.1_3d0faac70f5997e79e952e2be0702c36/node_modules/vue-loader/lib/index.js??vue-loader-options!./Template.vue?vue&type=template&id=6845f2d8", function () {
      api.rerender('6845f2d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/app/components/Template.vue"
export default component.exports